"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.97 3.687 5.937.009 6.933 0l.033 3.678-.996.009Zm2.65 1.17.888.45L11.705.976l-.889-.45-2.197 4.33Zm-4.845 10.01L2.166 9.004l7.38 3.762-5.77 2.1Zm2.773-4.985 3.076-1.959-3.334-1.73.258 3.689Zm.822.658 2.783-1.772.112 3.248L7.37 10.54ZM5.291 6.203 2.4 8.006l3.13 1.596-.238-3.4ZM3.483 16a.5.5 0 0 1-.43-.245.498.498 0 0 1-.128-.22L.907 8.18a.497.497 0 0 1 .216-.554l4.344-2.709c.15-.093.337-.1.493-.019l4.89 2.538c.16.083.263.245.269.425l.17 4.964a.497.497 0 0 1-.327.486L3.654 15.97a.484.484 0 0 1-.17.03ZM11.38 5.915l.58.81 2.988-2.146-.582-.809-2.986 2.145Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.973 5.22 9.926.01 11.047 0l.047 5.21-1.121.01Zm4.11 1.897 1 .508 3.17-6.25-1-.508-3.17 6.25ZM6.424 22.731 3.664 12.68l12.656 6.45-9.896 3.6Zm4.356-7.815 5.55-3.534-6.016-3.122.466 6.656Zm1.045.665 5.1-3.248.205 5.952-5.305-2.704ZM9.19 8.272l-5.266 3.283 5.7 2.905-.434-6.188ZM6.116 24a.56.56 0 0 1-.497-.302.552.552 0 0 1-.166-.268L2.246 11.752a.56.56 0 0 1 .243-.624l6.9-4.301a.56.56 0 0 1 .555-.022l7.766 4.03a.56.56 0 0 1 .302.478l.271 7.885a.56.56 0 0 1-.368.546L6.308 23.966a.56.56 0 0 1-.192.034ZM18.302 8.865l.654.911 4.231-3.04-.655-.911-4.23 3.04Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.296 6.96 13.235.013 14.729 0l.063 6.946-1.496.014Zm5.482 2.53 1.334.676 4.227-8.333-1.333-.677-4.228 8.333ZM8.566 30.306l-3.681-13.4 16.876 8.601-13.195 4.8Zm5.808-10.42 7.4-4.71-8.02-4.163.62 8.873Zm1.392.888 6.802-4.331.273 7.937-7.075-3.606Zm-3.51-9.746-7.022 4.377 7.6 3.874-.578-8.25ZM8.155 32a.746.746 0 0 1-.663-.403.736.736 0 0 1-.221-.358L2.995 15.67a.748.748 0 0 1 .325-.832l9.199-5.734a.747.747 0 0 1 .74-.03l10.355 5.373c.24.125.394.368.403.638l.36 10.513a.747.747 0 0 1-.49.728L8.41 31.955a.746.746 0 0 1-.256.045Zm16.247-20.18.872 1.215 5.642-4.054-.873-1.214-5.641 4.054Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M19.226 10.133 19.136.016 21.009 0l.091 10.117-1.874.016Zm8.357 3.936 1.67.847 6.218-12.255-1.672-.848-6.216 12.256ZM11.75 45.889l-5.74-20.89 26.304 13.407L11.75 45.89Zm8.743-15.671 11.749-7.482-12.734-6.609.985 14.09Zm1.887 1.02 10.856-6.914.435 12.669-11.291-5.756Zm-4.75-15.093L6.448 23.117l12.101 6.168-.919-13.139ZM11.26 48a.937.937 0 0 1-.847-.536.938.938 0 0 1-.305-.473L3.642 23.447a.936.936 0 0 1 .408-1.042l13.911-8.673a.935.935 0 0 1 .927-.037l15.658 8.127c.3.156.493.461.505.8l.545 15.896a.935.935 0 0 1-.615.912L11.58 47.944a.94.94 0 0 1-.32.056Zm24.837-30.277 1.093 1.521 8.216-5.903-1.093-1.521-8.217 5.903Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M25.635 13.51 25.514.023 28.012 0l.12 13.489-2.497.022Zm11.143 5.249 2.227 1.13 8.289-16.34-2.229-1.131-8.287 16.34ZM15.665 61.185 8.014 33.33l35.072 17.878-27.423 9.977ZM27.324 40.29l15.664-9.975-16.978-8.811 1.314 18.786Zm2.515 1.36 14.474-9.217.58 16.89-15.054-7.673Zm-6.331-20.122-14.91 9.295 16.135 8.224-1.225-17.52ZM15.013 64c-.473 0-.92-.27-1.129-.715a1.25 1.25 0 0 1-.407-.63L4.856 31.263a1.248 1.248 0 0 1 .545-1.39L23.949 18.31a1.246 1.246 0 0 1 1.236-.05l20.877 10.836c.4.208.657.615.672 1.066l.728 21.196c.02.54-.313 1.03-.82 1.216L15.44 63.925c-.14.051-.285.075-.427.075Zm33.115-40.37 1.458 2.03 10.955-7.872-1.458-2.028-10.955 7.87Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconValuables = function IconValuables(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Valuables' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Valuables"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconValuables.sizes = [16, 24, 32, 48, 64];
IconValuables.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconValuables;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/Valuables.js
// module id = 2045
// module chunks = 0